import { inject, Signal } from '@angular/core';
import { TenantsFacadeService } from '../../store/tenants/tenants.facade.service';

export const injectSupportEmail = (): Signal<string> => inject(TenantsFacadeService).serviceProviderSupportEmail;
